import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const KeyClockCompare = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: "icon authing-icon authing-yonghutiyan",
      title: t("solution.keycloak.compare.item1.title"),
      descript: t("solution.keycloak.compare.item1.descript"),
    },
    {
      icon: "icon authing-icon authing-biaozhunxieyi",
      title: t("solution.keycloak.compare.item2.title"),
      descript: t("solution.keycloak.compare.item2.descript"),
    },
    {
      icon: "icon authing-icon authing-webhook",
      title: t("solution.keycloak.compare.item3.title"),
      descript: t("solution.keycloak.compare.item3.descript"),
    },
    {
      icon: "icon authing-icon authing-shangyemaoyi",
      title: t("solution.keycloak.compare.item4.title"),
      descript: t("solution.keycloak.compare.item4.descript"),
    },
    {
      icon: "icon authing-icon authing-anzhuangbuding",
      title: t("solution.keycloak.compare.item5.title"),
      descript: t("solution.keycloak.compare.item5.descript"),
    },
    {
      icon: "icon authing-icon authing-genggaimimaHOVER-01",
      title: t("solution.keycloak.compare.item6.title"),
      descript: t("solution.keycloak.compare.item6.descript"),
    },
    {
      icon: "icon authing-icon authing-xukezheng",
      title: t("solution.keycloak.compare.item7.title"),
      descript: t("solution.keycloak.compare.item7.descript"),
    },
    {
      icon: "icon authing-icon authing-bushu-2",
      title: t("solution.keycloak.compare.item8.title"),
      descript: t("solution.keycloak.compare.item8.descript"),
    },
    {
      icon: "icon authing-icon authing-dingzhikaifa",
      title: t("solution.keycloak.compare.item9.title"),
      descript: t("solution.keycloak.compare.item9.descript"),
    },
  ];
  return (
    <section className="keyclock-compare">
      <div className="inner">
        <div className="top">
          <Title title={t("solution.keycloak.compare.title")}></Title>
        </div>
        <div className="content-warp">
          {features.map((item) => {
            return (
              <div className="content-item">
                <div className="icon">
                  <i className={item.icon} style={{ fontSize: 24 }}></i>
                </div>
                <div className="text">
                  <div className="title">{item.title}</div>
                  <div className="descript">{item.descript}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="security-tip">
          <div>
            <div className="description">{t("solution.keycloak.remark.descript")}</div>
          </div>
          <div>
            <img src={"//files.authing.co/authing-website/security-bg-icon.svg"} alt="authing keycloak remark" />
          </div>
        </div>
      </div>
    </section>
  );
};
